var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('permission-manager', { attrs: { "latchkey": "demo.project.push-log" } }, [_c('div', [_c('el-button', { attrs: { "type": "text" }, on: { "click": _vm.showDialog } }, [_vm._v(" 推送记录 ")]), _vm._v(" "), _c('el-dialog', { attrs: { "center": false, "title": "推送记录", "visible": _vm.visible, "close-on-click-modal": false, "append-to-body": true }, on: { "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      } } }, [_c('div', [_c('table-list', { directives: [{ name: "loading", rawName: "v-loading", value: _vm.loading, expression: "loading" }], ref: "pushTable", attrs: { "list": _vm.list, "columnConfig": _vm.tableColumnConfig } })], 1)])], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };